import React, { useEffect, useState } from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import API from '../../../../services/API'
import { Avatar, Chip, Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const MandatoryTrainingReview = () => {
  const [staff, setStaff] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    API.get('/staff-with-pending-mandatory-training').then(
      (res) => res.status === 200 && setStaff(res.data),
    )
  }, [])

  return (
    <Stack padding={2} gap={2}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          mb: 1,
        }}
      >
        Mandatory Training
      </Typography>
      <Typography variant="caption">
        The following staff have uploaded mandatory training certificates for
        you to review.
      </Typography>
      <Grid container spacing={2}>
        {staff.map((s) => (
          <Grid item key={s._id} sx={{ cursor: 'pointer' }}>
            <Chip
              sx={{ borderRadius: 1 }}
              avatar={<Avatar src={s.employee.userAccount.photograph} />}
              label={`${s.employee.userAccount.firstName} ${s.employee.userAccount.lastName}`}
              onClick={() =>
                navigate(
                  `/employees/${s.employee.userAccount._id}?tab=mandatorytraining`,
                )
              }
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  )
}

export default MandatoryTrainingReview
